/*
 * @Author: Dom
 * @Date: 2022-06-14 14:31:55
 * @LastEditTime: 2022-08-24 17:11:25
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\number.ts
 */
export function keepThreeNum(value: number | string):number{
    let num = 0
    const params = String(value)
    const newpar = parseFloat(params)
    const reg = /^[0-9]+.?[0-9]*$/
    if(reg.test(String(newpar))){
        num = Number(newpar.toFixed(3))
    }
    return num
}

export function keepTwoNum(value: number | string):number{
    let num = 0
    const params = String(value)
    const newpar = parseFloat(params)
    const reg = /^[0-9]+.?[0-9]*$/
    if(reg.test(String(newpar))){
        num = Number(newpar.toFixed(2))
    }
    return num
}

export function twoFloat(number:any){
    if(number.toString()==='NaN'){
        return '0.00'
    }else{
        let number1=number.toString().split(".");
        if(number1.length==1){
            number=number.toString()+".00";
            return number;
        }
        if(number1.length>1){
            if(number1[1].length<2){
                number=number.toString()+"0";
            }
            if(number1[1].length>2){
                number=number1[0]+"."+number1[1].substring(2,0);
            }
            return number;
        }
    }
 }
